module.exports = __webpack_public_path__ + "img/sld_inverter_t1_b1_green.b3590be2.svg";